import { Locales } from '@/constants/commons'

export function getPathWithoutLang(path: string, locale: Locales): string {
  let pathWithoutLang = path.startsWith(`/${locale}`) ? path.substring(locale.length + 1) : path
  if (pathWithoutLang.endsWith('/')) {
    pathWithoutLang = pathWithoutLang.slice(0, -1)
  }

  return pathWithoutLang
}
